<template>
    <div class="container">
        <div class="introduce" v-if="articleInfo">
            <div class="title">{{articleInfo.title}}</div>
            <div class="time">{{articleInfo.updateTime}}</div>
            <div class="content" v-html="articleInfo.content"></div>
        </div>
        <Hot></Hot>
    </div>
</template>

<script>
import * as apis from '../fetch/common';
import Hot from '../components/hot/Hot';

import { mapActions } from 'vuex';

export default {
    name: 'introduce',
    components: {
        Hot,
    },
    data() {
        return {
            articleInfo: null,
        };
    },
    watch: {
        $route(val) {
            this.getArticle(val.params.category);
        },
    },
    methods: {
        ...mapActions(['setBreadcrumb']),
        getArticle: function(category) {
            apis.getArticleByCategory(category).then(res => {
                this.articleInfo = res;
                this.setBreadcrumb(res.title);
            });
        },
    },
    mounted: function() {
        this.getArticle(this.$route.params.category);
    },
};
</script>

<style lang="less" scoped>
.container {
    display: flex;
    justify-content: space-between;
}
.introduce {
    width: 895px;
    background-color: #ffffff;
    box-shadow: 0px 0px 20px 0px rgba(228, 228, 228, 0.5);
    border-radius: 10px;
    margin-right: 10px;
    padding: 32px;
    height: max-content;
    .title {
        font-size: 20px;
        color: #2b2b2b;
        text-align: center;
    }
    .time {
        font-size: 18px;
        color: #8b8b8b;
        text-align: center;
        margin-top: 16px;
        margin-bottom: 24px;
    }
}
</style>